import {Component, OnDestroy, OnInit} from '@angular/core';
import {ConfiguratorTaskService, EngineEtlService, TaskDTO} from '@tj/tj-dmp-lib-api';
import {TasksService} from './tasks.service';
import {SelectItem} from 'primeng/api';
import {UtilsService} from '../../services/utils.service';

@Component({
    selector: 'dmp-tasks',
    templateUrl: './tasks.component.html',
    styleUrls: ['./tasks.component.scss'],
    standalone: false
})
export class TasksComponent implements OnInit, OnDestroy {
    /** Position de la fenêtre des tâches */
    position = 'bottom';
    displayDialogTasks = false;
    lastRefresh: Date;

    tasks: TaskDTO[] = [];

    private timer;
    private datastore: string;

    constructor(
        private tasksService: TasksService,
        private configuratorTaskService: ConfiguratorTaskService,
        private engineEtlService: EngineEtlService,
        private readonly utilsService: UtilsService
    ) {
    }

    ngOnDestroy(): void {
        clearInterval(this.timer);
    }

    ngOnInit() {
        this.tasksService.displayTasks.subscribe((value) => {
            this.displayDialogTasks = value;
            this.timer = this.refresh();
        });

        this.autoRefresh();
    }

    close() {
        this.tasksService.displayTasks.next(false);
    }

    autoRefresh() {
        this.timer = setInterval(this.refresh.bind(this), 30 * 1000);
    }

    refresh() {
        if (!this.displayDialogTasks) {
            return;
        }
        this.configuratorTaskService.getAllTasksUsingGET(this.datastore).subscribe((res) => {
            this.tasks = res.map(task => ({
                ...task,
                dateCreation: this.utilsService.normalizeTimestampToDate(task.dateCreation),
                dateFin: this.utilsService.normalizeTimestampToDate(task.dateFin),
                dateExec: this.utilsService.normalizeTimestampToDate(task.dateExec)
            }));
            this.tasks = this.tasks.sort((a: TaskDTO, b: TaskDTO) => {
                return new Date(b.dateCreation).getTime() - new Date(a.dateCreation).getTime();
            });
            this.lastRefresh = new Date();
        });
    }

    deleteTask(idTask: any): void {
        this.engineEtlService.deleteThreadForTaskUsingDELETE(idTask)
            .subscribe(() => this.refresh());
    }

    onChangeDataStore(datastore: SelectItem) {
        this.datastore = datastore.value;
        this.refresh();
    }
}
